<template>

  <!-- 헤더 -->
  <Header/>

  <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <router-link class="navbar-brand" :to="{name : 'Home'}">
      Childy Product List VUE.JS
    </router-link>
  </nav> -->
  
  <div class="container">
    <router-view/>
  </div>
  
  <!-- 푸터 -->
  <Footer/>
  
</template>

<script>
//components 폴더 안에 있는 product 폴더 안에 있는 prdItem.vue 파일을 import
import Header from '@/components/header/header.vue'
import Footer from '@/components/footer/footer.vue'
export default {
  components: {
    Header,
    Footer,
  },
}
</script>

<style>
</style>